import { render, staticRenderFns } from "./RentalIndex.vue?vue&type=template&id=0ade2ef4"
import script from "./RentalIndex.vue?vue&type=script&lang=js"
export * from "./RentalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports